module.exports = __webpack_public_path__ + "img/place-of-worship.e8c2f7a5.svg";